'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('../style/CardWrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardWrapper = function CardWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      border = _ref.border;

  var cardClasses = (0, _classnames2.default)('cp-card', className, { border: border });
  return _react2.default.createElement(
    'div',
    { className: cardClasses },
    children
  );
};

CardWrapper.propTypes = {
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  border: _react.PropTypes.bool
};

CardWrapper.defaultProps = {
  border: true
};

exports.default = CardWrapper;


// WEBPACK FOOTER //
// ../biblio-ui-glue/src/card/base/lib/components/CardWrapper.js